module.exports = __webpack_public_path__ + "img/brush-initial_cD.f26aec8f.png";